import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { toAbsoluteUrl } from "../../../../../../../../Utils/_helpers";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "16px",
    color: "#464e5f",
  },
}));

const SoundsDialog = (props) => {
  const {
    open,
    handleClose,
    title,
    children,
    maxWidth = "lg",
    width = "539px",
  } = props;
  const classes = useStyles();
  return (
    <div>
      <Dialog
        style={{ zIndex: "9991" }}
        aria-labelledby="dialog"
        disableBackdropClick
        open={open}
        fullWidth
        maxWidth={maxWidth}
        PaperProps={{
          style: {
            borderRadius: "4px",
            boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.03)",
            border: "solid 1px #f3f3f3",
            padding: "18px 24px 30.5px 18px",
            margin: "8px",
            width: width,
          },
        }}>
        <DialogTitle
          disableTypography
          className={` d-flex justify-content-between align-items-center py-1 px-2 pb-4`}>
          <Typography className={`${classes.title}`} variant="h6">
            {title}
          </Typography>
          <img
            alt="close"
            src={toAbsoluteUrl("/media/sr/icons/close.svg")}
            onClick={handleClose}
            style={{ cursor: "pointer", width: "20px", height: "20px" }}
          />
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </div>
  );
};

export default SoundsDialog;
